<template>
    <div>
        <p
            v-for="t in CLoadingTasks"
            :key="t">
            {{ t }}
        </p>
    </div>
</template>

<script lang="ts" setup>
const { $formatters } = useNuxtApp()

const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const CLoadingTasks = computed(() => {
  const loadingTasks = [] as string[]

  const { positions } = params?.value?.data || {}
  if (!positions || !positions.length) {
    return ''
  }

  positions?.forEach((p: any) => {
    if (Array.isArray(p?.tasks)) {
      p.tasks.forEach((t: any) => {
        if (t.taskName === 'Đóng hàng' && Array.isArray(t.timeConditions)) {
          t.timeConditions?.forEach((tc: any) => {
            loadingTasks.push($formatters.datetime(tc.time, 'DD/MM/YYYY h:mm A'))
          })
        }
      })
    }
  })
  return loadingTasks
})
</script>

<style scoped></style>
